import IconButton from "@mui/material/Button";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {DialogActions, DialogContent, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useState} from "react";
import {FxmsData} from "../../../datas/FxData";
import {AttrList} from "../../../datas/OpClass";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import {stringify} from "query-string";
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';

export const GridDataSelecter = (props) => {
    const [open, setOpen] = useState(false)
    const [urlList, setUrlList] = useState(['vup/select_4_5'])
    const [uri, setUri] = useState('')
    const [sample, setSample] = useState([])
    const [columns, setColumns] = useState({})
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [headerOrder, setHeaderOrder] = useState({})
    const [customUri, setCustomUri] = useState('')
    //커스텀전용
    const handleUriChange2 = () => {
        setLoading(true)
        setColumns({})
        setHeaderOrder({})
        selectGridData(uri,{})
    }
    //FxmData.selectGridData 는 애러를 리턴하지 않는 버그가 있음
    const selectGridData = (url, para, sortAttrName = "AAA", sortOrder = "ASC") => {
        let params = {};
        params.pagination = {};
        params.pagination.page = 1; // 첫 페이지
        params.pagination.perPage = 999999; // 999999건.
        params.filter = para;
        params.sort = {};
        params.sort.order = sortOrder;
        params.sort.field = sortAttrName;

        // 정의되지 않은 내용은 삭제한다.
        for (let key of Object.keys(para)) {
            if (para[key] === null || para[key] === "") {
                delete para[key];
            }
        }

        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify(params.filter),
        };
        const callUrl = `${url}?${stringify(query)}`;

        axios
            .get("/api/" + callUrl, FxmsData.getHeader())
            .then( (res) => {
                const columnsList = new AttrList("grid");
                res.data.map((x,index)=>{
                    x.id = index
                })
                let cols = []
                if(res.data.length > 0){
                    Object.keys(res.data[0]).map((x,index)=>{
                        cols.push({name:x,index:index,text:""})
                    })
                }
                setSample(cols)
                setData(res.data)
                setLoading(false)
            }).catch(err=>{
                alert("data error")
                setLoading(false)
        })
    }
    const handleUriChange = (e) => {
        setLoading(true)
        setUri(e.target.value)
        setColumns({})
        setHeaderOrder({})
        let params = {}

        selectGridData(e.target.value,params)
        // FxmsData.selectGridData(e.target.value, params ).then((res,err)=>{
        //     const columnsList = new AttrList("grid");
        //     res.data.map((x,index)=>{
        //         x.id = index
        //     })
        //     let cols = []
        //     if(res.data.length > 0){
        //         Object.keys(res.data[0]).map((x,index)=>{
        //             cols.push({name:x,index:index,text:""})
        //         })
        //     }
        //     setSample(cols)
        //     setData(res.data)
        //     setLoading(false)
        // })

    }
    const handleHeaderChange = (name,index,e) => {
        setColumns(prev=>({
            ...prev,[name]:{text:e.target.value,search:columns[name] ? columns[name].search  : false}
            }))
        setHeaderOrder(prev=>({
            ...prev,[name]:Object.keys(columns).indexOf(name)+1
            })
        )
    }
    const handleSearchBoxChange = (e,name) => {
        setColumns(prev=>({
            ...prev,
            [name]:{text:columns[name].text,search:e.target.checked}
        }))
    }
    const reset = () => {
        setColumns({})
        setHeaderOrder({})
        // let cols = []
        // if(data.length > 0){
        //     Object.keys(data[0]).map((x,index)=>{
        //         cols.push({name:x,index:index,text:""})
        //     })
        // }
        // setSample(cols)
    }
    const onSave = () => {
        setOpen(false)
        setHeaderOrder({})
        setColumns({})
        props.handleUriChange(uri,columns,data)
    }
    const handleClose = () => {
        setOpen(false)
        setLoading(false)
    }
    return (
        <div>
            <IconButton size={'small'} sx={{minWidth:0, right:'35px',position:'absolute',zIndex:999}} onClick={()=>setOpen(true)}>
                <SettingsIcon/>
            </IconButton>
            <Dialog fullWidth onClose={handleClose} open={open} maxWidth={'lg'}>
                <DialogTitle>데이터 API 및 필터 설정</DialogTitle>
                <DialogContent>
                    {loading ?
                        <Box sx={{zIndex:9999, transform:'translate(-50%, -50%)',position:'fixed',top:'50%',left:'50%'}}><CircularProgress size={100} color='secondary' /></Box> : ''}
                    <div>
                        <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"UI 주소 직접 입력"} onChange={(e)=>{setUri(e.target.value)}} />
                        <Button variant={"contained"} onClick={handleUriChange2}>조회</Button>
                    </div>
                    <div>
                        <FormControl sx={{margin:'15px'}}>
                            <Select
                                sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}
                                }}
                                fullWidth
                                value={uri}
                                onChange={handleUriChange}
                                input={<OutlinedInput />}
                            >
                                {urlList.map((x) => (
                                    <MenuItem className="dashboard_admin_select" key={x} value={x}>{x}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{maxWidth:'600px'}}>
                        {sample.map(x=>{
                            return<div key={x.index} style={{float:'left',display:'flex'}}>
                                <div style={{flex:1,minWidth:'25px',marginLeft:'5px'}}>{headerOrder[x.name]?headerOrder[x.name]:''}</div>
                                <TextField sx={{flex:4,input:{color:'white'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={x.name} onChange={handleHeaderChange.bind(this,x.name,x.index)} />
                                {Object.keys(columns).indexOf(x.name) != -1 ?
                                    <input
                                        type="checkbox"
                                        checked={columns[x.name]?columns[x.name].search:false}
                                        onChange={(e)=>{handleSearchBoxChange(e,x.name)}}
                                    />
                                    :''}

                            </div>

                        })}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant={"contained"} onClick={reset}>RESET</Button>
                    <Button variant={"contained"} onClick={onSave}>SAVE</Button>
                </DialogActions>
            </Dialog>
        </div>

    )
}